import * as Effects from 'redux-saga/effects'
import { all, call, put, take } from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import { fireToastSuccess } from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import updateTemplate from '../../models/Templates/updateTemplate'
import { TemplatesActions } from '../../reducers/templates/actionNames'
import { encodeEmojiForBackend } from '../../utils/encodeEmojiForBackend'
import fetchActionsName, { ActionNames } from '../../utils/FetchActionsName'

function formatContent(content) {
  let c = content.split('<div>')

  c = c.reduce(
    (a, b) =>
      a +
      (b.substr(0, 4) === '<br>' && b.substr(4, 6) !== '</div>'
        ? `<br />${b}`
        : b),
  )

  return c
    .split('</div>')
    .join('')
    .split('<b>')
    .join('')
    .split('</b>')
    .join('')
    .split('<br>')
    .join('<br />')
}

function* saveTemplates(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.SaveTemplate)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, updateTemplate)),
    ])

    const rawContent = formatContent(action.content)
      ? formatContent(action.content).replace(/\n/g, '<br />')
      : '<br />'
    yield call(service, {
      content: encodeEmojiForBackend(rawContent),
      id: action.idUser ? action.id : undefined,
      id_status: Number(action.idStatus),
      id_type: action.idType,
      lang: action.lang,
      title: action.title != null ? encodeEmojiForBackend(String(action.title)) : action.title,
      type_title: action.typeTitle,
    })

    yield Effects.put({ type: TemplatesActions.RequestForTemplates })

    yield Effects.put(
      fireToastSuccess(
        i18n.t('BBO_992_template_updated'),
        5000,
        'Main',
        'templateUpdated',
      ),
    )
  } catch (e) {
    console.error(e)
  }
}

export default function* () {
  yield Effects.takeLatest(TemplatesActions.SaveTemplates, saveTemplates)
}
